module.exports = __webpack_public_path__ + "media/assets/icons/viber-grey-73a3a7f2c248bc6561a79cfe5d2ffefc.svg";